import { render, staticRenderFns } from "./RecordCostUnitCreateModal.vue?vue&type=template&id=63123996"
import script from "./RecordCostUnitCreateModal.vue?vue&type=script&lang=js"
export * from "./RecordCostUnitCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports